import React from 'react';
import { FaClock, FaCheckCircle, FaTimesCircle, FaMapMarkerAlt } from 'react-icons/fa';
import { SavedLocation } from '../TimeIn';

interface StatusDisplayProps {
  isTimedIn: boolean;
  isWithinRadius: boolean;
  timeInTime: Date | null;
  lastAction: string;
  savedLocation: SavedLocation | null;
  onTimeAction: (action: 'in' | 'out') => void;
  hasAmTimeIn: boolean;
  hasAmTimeOut: boolean;
  hasPmTimeIn: boolean;
  hasPmTimeOut: boolean;
  isInAmWindow: boolean;
  isInPmWindow: boolean;
}

const StatusDisplay: React.FC<StatusDisplayProps> = ({
  isTimedIn,
  isWithinRadius,
  timeInTime,
  lastAction,
  savedLocation,
  onTimeAction,
  hasAmTimeIn,
  hasAmTimeOut,
  hasPmTimeIn,
  hasPmTimeOut,
  isInAmWindow,
  isInPmWindow
}) => {
  // Determine current session and button states (use props instead of recalculating)
  const isAm = isInAmWindow;
  const isPm = isInPmWindow;
  
  // Determine if Time In button should be disabled
  // Time In is disabled if:
  // - Not within radius
  // - Outside time windows (TEMPORARILY DISABLED)
  // - Already timed in for current session
  // - In PM and already timed in AM but not timed out AM (must complete AM first)
  const isTimeInDisabled = !isWithinRadius || 
    // TEMPORARILY DISABLED: (!isInAmWindow && !isInPmWindow) ||
    (isAm && hasAmTimeIn) || 
    (isPm && (hasPmTimeIn || (hasAmTimeIn && !hasAmTimeOut)));
  
  // Determine if Time Out button should be disabled
  // Time Out is disabled if:
  // - Not within radius
  // - Outside time windows (TEMPORARILY DISABLED)
  // - Not timed in for current session
  // - Already timed out for current session
  const isTimeOutDisabled = !isWithinRadius || 
    // TEMPORARILY DISABLED: (!isInAmWindow && !isInPmWindow) ||
    (isAm && (!hasAmTimeIn || hasAmTimeOut)) ||
    (isPm && (!hasPmTimeIn || hasPmTimeOut));
  
  // TEMPORARILY DISABLED: Get time restriction message
  // const getTimeRestrictionMessage = () => {
  //   if (!isInAmWindow && !isInPmWindow) {
  //     return 'Time In/Out is only allowed during AM (8:00 AM - 12:58 PM) or PM (12:59 PM - 5:59 PM) sessions';
  //   }
  //   if (isAm) {
  //     if (hasAmTimeIn && hasAmTimeOut) {
  //       return 'AM session completed. PM session available at 12:59 PM';
  //     }
  //     return 'AM session: 8:00 AM - 12:58 PM';
  //   }
  //   if (isPm) {
  //     if (hasPmTimeIn && hasPmTimeOut) {
  //       return 'PM session completed for today';
  //     }
  //     return 'PM session: 12:59 PM - 5:59 PM';
  //   }
  //   return '';
  // };

  return (
    <div className="status-section">
      {savedLocation ? (
        <>
          <p><FaMapMarkerAlt className="inline-icon" /> Selected Location: <span className="status-text">{savedLocation.name}</span></p>
          <p>Status: <span className={`status-text ${isTimedIn ? 'timed-in' : ''}`}>
            {isTimedIn ? (
              <><FaCheckCircle className="inline-icon timed-in-icon" /> Currently Timed In</>
            ) : (
              <><FaClock className="inline-icon" /> Not Timed In</>
            )}
          </span></p>
          <p>Location: <span className={`status-text ${isWithinRadius ? 'in-range' : 'out-of-range'}`}>
            {isWithinRadius ? (
              <><FaCheckCircle className="inline-icon in-range-icon" /> Within work area</>
            ) : (
              <><FaTimesCircle className="inline-icon out-of-range-icon" /> Outside work area</>
            )}
          </span></p>
          {isTimedIn && timeInTime && (
            <p>Time In Duration: <span className="status-text">
              {Math.round((new Date().getTime() - timeInTime.getTime()) / (1000 * 60))} minutes
            </span></p>
          )}
          <p>Last Action: <span className="action-text">{lastAction}</span></p>
          
          {/* TEMPORARILY DISABLED: Time restriction message */}
          {/* <p className="time-restriction-message">{getTimeRestrictionMessage()}</p> */}

          <div className="button-group">
            <button 
              type="button" 
              className={`time-btn ${isTimeInDisabled ? 'disabled' : ''}`}
              onClick={() => onTimeAction('in')}
              disabled={isTimeInDisabled}
            >
              Time In
            </button>
            <button 
              type="button" 
              className={`time-btn ${isTimeOutDisabled ? 'disabled' : ''}`}
              onClick={() => onTimeAction('out')}
              disabled={isTimeOutDisabled}
            >
              Time Out
            </button>
          </div>
        </>
      ) : (
        <p>Select a location or add a new one to start timing in/out.</p>
      )}
    </div>
  );
};

export default StatusDisplay;

